import classNames from 'classnames';
import { IconProps } from '~/components/Icon/Icon';
import styles from './Chevron.module.scss';

export type NewChevronProps = IconProps & {
  direction?: 'right' | 'bottom' | 'left' | 'top';
  size?: 'small' | 'large';
  width?: number;
};

export const Chevron = ({
  className,
  direction = 'right',
  size = 'large',
  width = 1.21875,
  ...props
}: NewChevronProps) => (
  <svg
    className={classNames(styles.root, className, styles[direction], styles[size])}
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    {...props}>
    <path
      d="M9.96655 8.39795L6.5455 4.9769L3.12445 8.39795"
      stroke="currentColor"
      strokeWidth={width}
      strokeLinecap="round"
    />
  </svg>
);
